import {Injectable} from '@angular/core';
import {catchError, forkJoin, map, Observable, Subject} from 'rxjs';
import {
    Canton,
    Commune,
    Domaine,
    GeneralResponse,
    Offre,
    Pays,
    Prefecture,
    Region,
    Specialite,
    StatutJuridique,
    TypeDiplome,
    TypePiece,
    TypeStructure
} from './parametre.model';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {of} from 'rxjs/internal/observable/of';
import {Role} from '../securite/auth.model';
import {Information} from '../admin/admin.model';
import {environment} from '../../../environments/environment';
import {GuideDetailsComponent} from '../guide/guide-view/guide-details/guide-details.component';
import {tap} from 'rxjs/operators';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
@Injectable({
  providedIn: 'root'
})
export class ParametreService {

  urlApi = environment.globals.urlApi;
  guideDetailsSelected: Information;
    isLoading=true;

  // tslint:disable-next-line:new-parens
  regionSubject = new Subject<Region[]>();
  roleSubject = new Subject<Role[]>();
  prefectureSubject = new Subject<Prefecture[]>();
  communeSubject = new Subject<Commune[]>();
  cantonSubject = new Subject<Canton[]>();
  typeInformationSubject = new Subject<Information[]>();
  typeStructureSubject = new Subject<TypeStructure[]>();
  statutJuridiqueSubject = new Subject<StatutJuridique[]>();
  specialitesSubject = new Subject<Specialite[]>();
  typeDiplomesSubject = new Subject<TypeDiplome[]>();
  domainesSubject = new Subject<Domaine[]>();
    typePiecesSubject = new Subject<TypePiece[]>();
    paysSubject = new Subject<Pays[]>();
    offresSubject = new Subject<Offre[]>();

  regions: Region[];
  roles: Role[];
  prefectures: Prefecture[];
  communes: Commune[];
  cantons: Canton[];
  typeStructures: TypeStructure[];
  statutJuridiques: StatutJuridique[];
  specialites: Specialite[];
  typeDiplomes: TypeDiplome[];
  informations: Information[];
  domaines: Domaine[];
  pays: Pays[];
  typePieces: TypePiece[];
  offres: Offre[];


  constructor(private http: HttpClient,
  ) {
      // //console.log("param authservice user ",this.authService.loggedUser);
      //console.log("constructeur ss ",this.ss);
      //console.log("param constructeur ss ",this.ss);
      //console.log("param url : ",this.urlApi);



      // this.urlApi=

  }



    getInfos(httpHeaders:HttpHeaders,roleId,type):Observable<Information[]> {
        this.isLoading=true;
     return this.http.post<GeneralResponse>(this.urlApi  + '/admin/user/information/list',{
         'role_id':roleId,
         'type':type
     }, {headers: httpHeaders})
            .pipe(
                map(response => {
                    this.isLoading=false;
                    return response.data as Information[]; // Type assertion for clarity

                }),
                catchError(error => {
                    console.error('Error fetching Informations:', error);
                    return of([]); // Return an empty observable on error
                })
            )

    }

    getOffre(httpHeaders:HttpHeaders){
        console.log("offres param encours");
        this.http.get<GeneralResponse>(this.urlApi  + '/offre/list', {headers: httpHeaders})
            .pipe(
                map(response => {
                    const datas = response.data as Offre[]; // Type assertion for clarity

                    console.log("offres param",datas);
                    return datas;
                }),
                catchError(error => {
                    console.error('Error fetching offres:', error);
                    return of([]); // Return an empty observable on error
                })
            ).subscribe(
            {
                next: (responses: Offre[]) => {
                    this.offres = responses;
                    // this.pays.reverse();
                    // .sort((a, b) => a.libelle.localeCompare(b.libelle));
                    this.emitOffre();
                },
            }
        );
    }



    getTypeStructures(httpHeaders: HttpHeaders): Observable<TypeStructure[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/core/typestructures', { headers: httpHeaders }).pipe(
            map(response => response.data as TypeStructure[]),
            catchError(error => {
                console.error('Error fetching Type structures:', error);
                return of([]);
            })
        );
    }

    getInformations(httpHeaders: HttpHeaders): Observable<Information[]> {
        return this.http.post<GeneralResponse>(this.urlApi + '/admin/information/list', {}, { headers: httpHeaders }).pipe(
            map(response => response.data as Information[]),
            catchError(error => {
                console.error('Error fetching Informations:', error);
                return of([]);
            })
        );
    }

    getStatusJuridiques(httpHeaders: HttpHeaders): Observable<StatutJuridique[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/core/statutjuridiques', { headers: httpHeaders }).pipe(
            map(response => response.data as StatutJuridique[]),
            catchError(error => {
                console.error('Error fetching statut juridiques:', error);
                return of([]);
            })
        );
    }

    getSpecialites(httpHeaders: HttpHeaders): Observable<Specialite[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/core/specialites', { headers: httpHeaders }).pipe(
            map(response => response.data as Specialite[]),
            catchError(error => {
                console.error('Error fetching specialites:', error);
                return of([]);
            })
        );
    }

    getTypeDiplomes(httpHeaders: HttpHeaders): Observable<TypeDiplome[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/core/typediplomes', { headers: httpHeaders }).pipe(
            map(response => response.data as TypeDiplome[]),
            catchError(error => {
                console.error('Error fetching TypeDiplomes:', error);
                return of([]);
            })
        );
    }

    getDomaines(httpHeaders: HttpHeaders): Observable<Domaine[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/core/domaines', { headers: httpHeaders }).pipe(
            map(response => response.data as Domaine[]),
            catchError(error => {
                console.error('Error fetching domaines:', error);
                return of([]);
            })
        );
    }

    getPays(httpHeaders: HttpHeaders): Observable<Pays[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/core/pays', { headers: httpHeaders }).pipe(
            map(response => response.data as Pays[]),
            catchError(error => {
                console.error('Error fetching pays:', error);
                return of([]);
            })
        );
    }

    getOffre2(httpHeaders: HttpHeaders): Observable<Offre[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/offre/list', { headers: httpHeaders }).pipe(
            map(response => response.data as Offre[]),
            catchError(error => {
                console.error('Error fetching offre:', error);
                return of([]);
            })
        );
    }

    getTypePieces(httpHeaders: HttpHeaders): Observable<TypePiece[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/core/typepieces', { headers: httpHeaders }).pipe(
            map(response => response.data as TypePiece[]),
            catchError(error => {
                console.error('Error fetching type pieces:', error);
                return of([]);
            })
        );
    }

    getRegions(httpHeaders: HttpHeaders): Observable<Region[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/core/regions', { headers: httpHeaders }).pipe(
            map(response => response.data as Region[]),
            catchError(error => {
                console.error('Error fetching regions:', error);
                return of([]);
            })
        );
    }

    getPrefectures(httpHeaders: HttpHeaders): Observable<Prefecture[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/core/prefectures', { headers: httpHeaders }).pipe(
            map(response => response.data as Prefecture[]),
            catchError(error => {
                console.error('Error fetching prefectures:', error);
                return of([]);
            })
        );
    }

    getCommunes(httpHeaders: HttpHeaders): Observable<Commune[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/core/communes', { headers: httpHeaders }).pipe(
            map(response => response.data as Commune[]),
            catchError(error => {
                console.error('Error fetching communes:', error);
                return of([]);
            })
        );
    }

    getCantons(httpHeaders: HttpHeaders): Observable<Canton[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/core/cantons', { headers: httpHeaders }).pipe(
            map(response => response.data as Canton[]),
            catchError(error => {
                console.error('Error fetching cantons:', error);
                return of([]);
            })
        );
    }

    getRoles(httpHeaders: HttpHeaders): Observable<Role[]> {
        return this.http.get<GeneralResponse>(this.urlApi + '/core/role/list', { headers: httpHeaders }).pipe(
            map(response => response.data as Role[]),
            catchError(error => {
                console.error('Error fetching roles:', error);
                return of([]);
            })
        );
    }


    initCommonParams(): Observable<void> {
        let httpHeaders: HttpHeaders;
        this.getOffre(httpHeaders);
        return forkJoin({
            roles: this.getRoles(httpHeaders),
            typeStructures: this.getTypeStructures(httpHeaders),
            informations: this.getInformations(httpHeaders),
            statutJuridiques: this.getStatusJuridiques(httpHeaders),
            specialites: this.getSpecialites(httpHeaders),
            typeDiplomes: this.getTypeDiplomes(httpHeaders),
            domaines: this.getDomaines(httpHeaders),
            pays: this.getPays(httpHeaders),
            // offres: this.getOffre(httpHeaders),
            typePieces: this.getTypePieces(httpHeaders),
            regions: this.getRegions(httpHeaders),
            prefectures: this.getPrefectures(httpHeaders),
            communes: this.getCommunes(httpHeaders),
            cantons: this.getCantons(httpHeaders),
        }).pipe(
            tap(results => {
                this.roles = results.roles;
                this.typeStructures = results.typeStructures;
                this.informations = results.informations;
                this.statutJuridiques = results.statutJuridiques;
                this.specialites = results.specialites;
                this.typeDiplomes = results.typeDiplomes;
                this.domaines = results.domaines;
                this.pays = results.pays;
                // this.offres = results.offres;
                this.typePieces = results.typePieces;
                this.regions = results.regions;
                this.prefectures = results.prefectures;
                this.communes = results.communes;
                this.cantons = results.cantons;


                // Émettre les données après chargement
                this.emitRoles();
                this.emitTypeSturctures();
                this.emitInformations();
                this.emitStatutJuridique();
                this.emitSpecialites();
                this.emitTypediplomes();
                this.emitDomaines();
                this.emitPays();
                this.emitOffre();
                this.emitTypePieces();
                this.emitRegions();
                this.emitPrefectures();
                this.emitCommunes();
                this.emitCantons();


                console.log('Toutes les données sont chargées. :',results);
            }),
            map(() => void 0) // Transforme l'Observable en Observable<void>
        );
    }

    initStructureParams() {
      // this.initCommonParams();
      // this.getInformations();



    }
    public getToken(): string | null {
        return window.sessionStorage.getItem(TOKEN_KEY);
    }
    getHeaders(token?: string) {

        if(this.getToken() !== null) {
            valueToken = this.getToken();
        } //console.log("Mon token",token);
        var valueToken = '';

        //console.log("Mon token",valueToken);

        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token!=undefined ? token: this.getToken()}`
        });

        // return {
        //   'Content-Type': 'application/json',
        //   'accept': 'application/json',
        //   'Access-Control-Allow-Origin': this.server,
        //   'Authorization': 'Bearer ' + token ? token: valueToken
        //   };
    }


    initAllParams(httpHeaders: HttpHeaders) {
        // this.initCommonParams(httpHeaders)
        // this.initCandidatParams();
        // this.initStructureParams();
    }

    emitTypeSturctures() {
        this.typeStructureSubject.next(this.typeStructures);
    }

    emitInformations() {
        this.typeInformationSubject.next(this.informations);
    }
    emitStatutJuridique() {
        this.statutJuridiqueSubject.next(this.statutJuridiques);
    }
    emitSpecialites() {
        this.specialitesSubject.next(this.specialites);
    }

    emitRoles() {
        this.roleSubject.next(this.roles);
    }
    emitTypediplomes() {
        this.typeDiplomesSubject.next(this.typeDiplomes);
    }
    emitDomaines() {
        this.domainesSubject.next(this.domaines);
    }
    emitPays() {
        this.paysSubject.next(this.pays);
    }
    emitOffre() {
        this.offresSubject.next(this.offres);
    }
    emitTypePieces() {
        this.typePiecesSubject.next(this.typePieces);
    }
    emitRegions() {
        this.regionSubject.next(this.regions);
    }
    emitPrefectures() {
        this.prefectureSubject.next(this.prefectures);
    }
    emitCommunes() {
        this.communeSubject.next(this.communes);
    }
    emitCantons() {
        this.cantonSubject.next(this.cantons);
    }

}
